import axios from 'Axios';

export default {
  getUserProfile() {
    return axios.get('/profile/supply');
  },
  updateUserProfile(data) {
    return axios.post('/profile/supply', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  getCompanyInfo() {
    return axios.get('/profile/company');
  },

  updateCompanyInfo(data) {
    return axios.post('/profile/company', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  deleteAsset(imageId) {
    return axios.delete('asset/' + imageId);
  },
};
